import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import firebase from 'firebase/compat/app';

import ErrorBoundary from './pages/ErrorBoundary';
import LoginPage from './pages/LoginPage';
import AuthPage from './pages/AuthPage';
import RegistrationPage from './pages/RegistrationPage';
import Logout from './pages/Logout';
import DefaultController from './controller/DefaultController';
import { getMessaging, getToken } from 'firebase/messaging';
import { analytics, messaging } from './firebase';
import Util from './util/Util';
import config from './config/config';
import { logEvent } from 'firebase/analytics';

class App extends React.Component {

  constructor(pros) {
    super(pros);
    firebase.initializeApp(config.firebase);
  }

  static onPay = () => {
    Util.showNotification('Unbilled CRM', 'Please contact your sales person and pay crm charges', 'danger');
    window.location.href = config.auth + 'billing';
  };

  static onLogout = () => {
    Util.showNotification('Logged Out', 'You have been logged out of system', 'danger');
    reactLocalStorage.clear();
    window.location.href = config.auth + 'logout';
  };

  static onFail = response => {
    //const message = response && response.message ? response.message
    //  : response ? response : 'Please check internet or contact support';
    //Util.showNotification('Failure', message, 'danger');
  };

  checkInternetIsOn = () => {
    if (!navigator.onLine) {
      Util.showNotification('Failure', 'Internet Is Gone', 'danger');
    }
  };

  // Initialize Firebase Messaging and request notification permission
  initializeFirebaseMessaging = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        const token = await getToken(messaging, {
          vapidKey: config.firebase.vapId
        });
        if (token) {
          // console.log('FCM Token:', token);
        } else {
          console.log('No registration token available.');
        }
      } else {
        console.log('Notification permission denied.');
      }
    } catch (err) {
      console.error('Error initializing Firebase Messaging:', err);
      Util.showNotification('Failure', 'Failed to set up notifications', 'danger');
    }
  };

  // Register service worker
  registerServiceWorker = () => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/firebase-messaging-sw.js')
          .then((registration) => {
            registration.active?.postMessage({ type: 'INIT' });
          })
          .catch((err) => {
            console.error('Service Worker registration failed:', err);
            Util.showNotification('Failure', 'Failed to register service worker', 'danger');
          });
      });
    } else {
      console.log('Service Workers not supported in this browser.');
    }
  };

  componentDidMount() {
    logEvent(analytics, 'app_opened');
    this.checkInternetIsOn();
    navigator.serviceWorker.addEventListener('message', event => {
      if (event.data && event.data.type === 'NOTIFICATION_NAVIGATE') {
        window.location.href = event.data.url;
      }
    });
    window.addEventListener('online', this.handleOnlineStatusChange);
    window.addEventListener('offline', this.handleOnlineStatusChange);
    // Register service worker
    this.registerServiceWorker();
    // Initialize Firebase Messaging
    this.initializeFirebaseMessaging();
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.handleOnlineStatusChange);
    window.removeEventListener('offline', this.handleOnlineStatusChange);
  }

  handleOnlineStatusChange = () => {
    this.checkInternetIsOn();
  };
  render() {
    return (
      <ErrorBoundary>
        <Routes>
          <Route path="/registration" element={<RegistrationPage />} />
          <Route path="/auth/:auth" element={<AuthPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="*" element={<DefaultController />} />
        </Routes>
      </ErrorBoundary>
    );
  }
}
export default App;